module.exports = __webpack_public_path__ + "static/img/success.d01305ff.png";